export default __webpack_public_path__ + "static/media/aniscoot1.33793c8f.webp";